/** Small inline icons. The diamond is the Mastery wordmark motif. */

import { MARK_ASPECT, MARK_PATH, MARK_VIEWBOX } from "../brandMark";

export function Diamond({ size = 13 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 14 14" aria-hidden="true">
      <rect x="1.5" y="1.5" width="8" height="8" transform="rotate(45 5.5 5.5)" fill="currentColor" />
    </svg>
  );
}

export function Check({ size = 12 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 12 12" aria-hidden="true">
      <path
        d="M2.5 6.3l2.3 2.3 4.7-5"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function Warn({ size = 14 }: { size?: number }) {
  return (
    <svg width={size} height={size} viewBox="0 0 12 12" aria-hidden="true">
      <path d="M6 1.6l5 8.8H1z" stroke="currentColor" strokeWidth="1.3" fill="none" strokeLinejoin="round" />
      <path d="M6 4.9v2.2M6 8.7v.1" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
    </svg>
  );
}

/**
 * The Mastery mark — the real one, traced from the artwork. `size` is its
 * height; the mark is wider than tall. See src/brandMark.ts.
 */
export function BrandMark({ size = 42 }: { size?: number }) {
  return (
    <svg
      className="intro-mark"
      width={size * MARK_ASPECT}
      height={size}
      viewBox={MARK_VIEWBOX}
      aria-hidden="true"
    >
      <path d={MARK_PATH} fill="currentColor" />
    </svg>
  );
}
